import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import PrintViewResult from "../../PrintViewResult";
const useStyles = makeStyles((theme) => ({
  footer: {
    marginTop: 12,
    
    [theme.breakpoints.down("md")]: {
      paddingLeft: 20,
      paddingRight: 20,
    },
  },
  backButton: {
    flex: 1,
    height: 78,
    fontSize: 20,
    backgroundColor: "#ffffff",
    "&:hover": {
      backgroundColor: "#ffffff",
    },
    content: `"테스트입니다"`,
    "& .MuiButton-label": {
      content: `"테스트입니다"`,
    },
    [theme.breakpoints.down("md")]: {
      width: "calc(50% - 20px)",
      height: 58,
      fontSize: 18,
    },
    [theme.breakpoints.down("sm")]: {
      width: "48%",
      height: 58,
      fontSize: 18,
    },
  },
  button: {
    flex: 1,
    height: 78,
    marginLeft: 20,
    fontSize: 20,
    [theme.breakpoints.down("md")]: {
      width: "calc(50% - 20px)",
      height: 58,
      fontSize: 18,
    },
    [theme.breakpoints.down("sm")]: {
      width: "calc(50% - 4px)",
      height: 58,
      fontSize: 18,
    },
  },
  buttonPrev: {
    flex: 1,
    height: 78,
    marginRight: 20,
    fontSize: 20,
    color: '#10459a',
    borderWidth: 1,
    borderColor: '#10459a',
    borderStyle: 'solid',
    backgroundColor: 'f5faff',
    [theme.breakpoints.down("md")]: {
      width: "calc(50% - 20px)",
      height: 58,
      fontSize: 18,
    },
    [theme.breakpoints.down("sm")]: {
      width: "calc(50% - 4px)",
      height: 58,
      fontSize: 18,
    },
  },
  large: {
    display: "block",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  small: {
    display: "none",
    [theme.breakpoints.down("md")]: {
      display: "block",
    },
  },
  desk: {
    display: "block",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  tablet: {
    display: "none",
    [theme.breakpoints.down("md")]: {
      width: "calc(50% - 20px)",
      display: "block",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  mobil: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      width: "calc(50% - 4px)",
      display: "block",
    },
  },
}));
const CancerPrintFooter = ({
  cancer = "폐암",
  complete,
  lungRe,
  total,
  queData,
  handleNotComple,
  handlePageMove,
  handlePrevMove,
}) => {
  const classes = useStyles();
  return (
    <Grid
      container
      justify={cancer == '갑상선암' ? 'center' : "space-between"}
      alignItems="center"
      className={classes.footer}
    >
      <Button
        onClick={() => handlePrevMove()}
        className={classes.buttonPrev}
      >
        이전
      </Button>
      {complete ? (
        <>
          <Grid className={classes.desk}>
            <PrintViewResult
              large={3}
              data={lungRe}
              total={total}
              cancer={cancer}
              queData={queData}
              fullMode={true}
            />
          </Grid>
          <Grid className={classes.tablet}>
            <PrintViewResult
              large={2}
              data={lungRe}
              total={total}
              cancer={cancer}
              queData={queData}
              fullMode={true}
            />
          </Grid>
          <Grid className={classes.mobil}>
            <PrintViewResult
              large={1}
              data={lungRe}
              total={total}
              cancer={cancer}
              queData={queData}
              fullMode={true}
            />
          </Grid>
        </>
      ) : (
        cancer == '갑상선암' ? null : (
          <Button
          onClick={() => handleNotComple()}
          variant="outlined"
          color="primary"
          className={classes.backButton}
        >
          <span className={classes.large}>
            {cancer} 발생위험도와 나의 결정 출력
          </span>
          <span className={classes.small}>출력</span>
        </Button>
        )
      )}
      {/* <LungDecisionButton /> */}
      {/* <Button
          onClick={() => onPageChange(0)}
          variant="outlined"
          color="primary"
          className={classes.button}
        >
          폐암 발생위험도와 나의 결정 출력
        </Button> */}        
      <Button
        onClick={() => handlePageMove()}
        variant="contained"
        color="primary"
        className={classes.button}
      >
        완료
      </Button>
    </Grid>
  );
};

export default CancerPrintFooter;
